const Testimonials = () => {
  return (
    <section id="testimonios" className="py-20 bg-gradient-to-br from-neutral-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary-800 mb-6">
            Centros Colaboradores
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-accent-500 mx-auto rounded-full"></div>
          <p className="text-neutral-600 mt-6 text-lg">
            La confianza de los profesionales veterinarios que trabajan conmigo
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10 border border-neutral-100 hover:shadow-2xl transition-shadow duration-300">
            {/* Header con foto y nombre */}
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-14 h-14 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-xl font-bold">OV</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-primary-800 text-lg">
                  Óscar Valdivia Cárdenas
                </h3>
                <p className="text-accent-600 text-sm font-medium">
                  GPcert Oncology
                </p>
                <p className="text-neutral-500 text-sm mt-1">
                  Clínica Veterinaria Valdivia
                </p>
              </div>
            </div>

            {/* Estrellas */}
            <div className="flex items-center space-x-1 mb-6">
              {[1, 2, 3, 4, 5].map((star) => (
                <i 
                  key={star} 
                  className="ri-star-fill text-accent-500 text-xl"
                ></i>
              ))}
            </div>

            {/* Comentario */}
            <div className="space-y-4 text-neutral-700 leading-relaxed">
              <p className="text-lg">
                "Colaborar con Pablo Conejero es una garantía.
              </p>
              <p className="text-lg">
                Su capacitación técnica y científica son de máximo nivel.
              </p>
              <p className="text-lg">
                Y lo que lo hace único, es su predisposición a integrarse en el equipo y el ritmo de trabajo de nuestro centro.
              </p>
              <p className="text-lg">
                Nos ha ayudado mucho a dar un salto cualitativo en el cuidado de nuestros pacientes.
              </p>
              <p className="text-lg font-semibold text-primary-800">
                Absolutamente recomendable."
              </p>
            </div>

            {/* Badge verificado */}
            <div className="mt-8 pt-6 border-t border-neutral-100">
              <div className="flex items-center space-x-2 text-primary-600">
                <i className="ri-shield-check-line text-xl"></i>
                <span className="text-sm font-medium">Centro Colaborador Verificado</span>
              </div>
            </div>
          </div>

          {/* Elemento decorativo */}
          <div className="mt-12 text-center">
            <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-primary-50 to-accent-50 px-8 py-4 rounded-full border border-primary-100">
              <i className="ri-team-line text-primary-600 text-2xl"></i>
              <span className="text-primary-800 font-semibold">
                + de 23 Centros Veterinarios Colaboradores
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
